import React, { useRef, useEffect } from "react";
import * as echarts from "echarts/lib/echarts";

let myChart = null;
export default ({ id, width, height, chartData, chartTitle }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef) {
      setTimeout(() => {
        setChart();
      }, 100);
    }
    return () => {
      myChart = null;
      window.removeEventListener("resize", resizeFn);
    };
  }, [chartData]);

  const resizeFn = () => {
    myChart.resize();
  };

  const setChart = () => {
    const seriesData = [];
    let xAxisData = [];
    if (chartData && chartData.length > 0) {
      chartData.forEach((item) => {
        seriesData.push({
          name: item.iconStr,
          type: "line",
          smooth: true,
          data: item.totalArr.map((s) => s.numAll),
        });
      });
      xAxisData = chartData[0].totalArr.map((item) => item.timeIcon);
    }
    const option = {
      color: [
        "#5253FF",
        "#58E498",
        "#E358E4",
        "#FFCD62",
        "#0069DF",
        "#FFCC99",
        "#6666CC",
        "#7ED067",
        "#00A300",
        "#00BFFF",
      ],
      title: {
        text: chartTitle,
        textStyle: {
          color: "#fff",
          fontSize: 18,
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#fff",
          },
          lineStyle: {
            type: "dashed",
          },
        },
      },
      grid: {
        bottom: "0",
        left: "2%",
        right: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: xAxisData,
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          color: "#fff",
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          color: "#fff",
          interval: 0, // 0表示显示所有标签
          fontSize: 12,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#fff",
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        name: "",
      },
      series: seriesData,
    };
    myChart = echarts.init(chartRef.current);
    myChart.setOption(option);
    window.addEventListener("resize", resizeFn);
  };

  return <div id={id} ref={chartRef} style={{ width, height }}></div>;
};
